import axios from 'axios'
import React, { createContext, useContext, useEffect, useState } from 'react'

const GraphContext = createContext()

export const    GarphProvider = ({ graphId, getGraph, getGraphFunction, initialGraph, children }) => {
    const [ graphFig, setGraphFig ] = useState(initialGraph)
    const [ correlation, setcorrelation ] = useState({})

    useEffect(() => {
        graphId 
        && (async () => {
            const res = await getGraph(graphId)
            setcorrelation(res.correlation)
            setGraphFig(res)
        })()
        return () => setGraphFig(initialGraph)
    }, [graphId, getGraph, initialGraph])

    const handleGraphFunction = async (data) => {
        setGraphFig({...data, fig: null})
        const res = await getGraphFunction(data, graphId) 
        setcorrelation(res.correlation)
        setGraphFig(res)
    }

    const updateTimeFrame = async (timeFrame) => {
        const resJson = await axios({
            method:'put',
            url:'/api/updateGraphTimeFrame',
            data:{timeFrame, graphId}
        })
        
        const res = await resJson.data
        res.status === 200 && setGraphFig({...graphFig, timeFrame})
    }

    return (
        <GraphContext.Provider value={{
            graphFig,
            correlation,
            handleGraphFunction,
            updateTimeFrame,
            timeFrame: graphFig.timeFrame,
        }}>
            { children}
        </GraphContext.Provider>
    )

}

export function useGraphContext() {
    return useContext(GraphContext)
}